import type { ClientProfileResponse } from "./ClientProfileResponse";
import type { ClientProfileRequest } from "./ClientProfileRequest";

export class ClientListItem {
  clientId: number;
  userId: number | null;
  firstName: string;
  lastName: string;
  fullName: string;
  personalCode: string;
  phoneNumber: string | null;
  email: string | null;
  address: string | null;
  clientCategoryLookupId: number;
  clientTypeLookupId: number | null;
  defaultLanguageLookupId: number | null;
  serviceLookupIds: number[];
  serviceLookupNames: string[];
  preferenceLookupIds: number[];
  hasUser: boolean;
  isActive: boolean;
  inactiveReason: string | null;
  createdDate: string;
  createdBy: string;
  modifiedDate: string;
  modifiedBy: string;

  constructor(response: ClientProfileResponse) {
    this.clientId = response.clientId;
    this.userId = response.userId;
    this.firstName = response.firstName;
    this.lastName = response.lastName;
    this.fullName = response.fullName;
    this.personalCode = response.personalCode;
    this.phoneNumber = response.phoneNumber;
    this.email = response.email;
    this.address = response.address;
    this.clientCategoryLookupId = response.clientCategoryLookupId;
    this.clientTypeLookupId = response.clientTypeLookupId;
    this.defaultLanguageLookupId = response.defaultLanguageLookupId;
    this.serviceLookupIds = response.serviceLookupIds;
    this.serviceLookupNames = response.serviceLookupNames;
    this.preferenceLookupIds = response.preferenceLookupIds;
    this.hasUser = response.hasUser;
    this.isActive = response.isActive;
    this.inactiveReason = response.inactiveReason;
    this.createdDate = response.createdDate;
    this.createdBy = response.createdBy;
    this.modifiedDate = response.modifiedDate;
    this.modifiedBy = response.modifiedBy;
  }

  toRequest(): ClientProfileRequest {
    return {
      firstName: this.firstName,
      lastName: this.lastName,
      personalCode: this.personalCode,
      phoneNumber: this.phoneNumber,
      email: this.email,
      address: this.address,
      clientCategoryLookupId: this.clientCategoryLookupId,
      clientTypeLookupId: this.clientTypeLookupId,
      defaultLanguageLookupId: this.defaultLanguageLookupId,
      serviceLookupIds: this.serviceLookupIds.length > 0 ? this.serviceLookupIds : null,
      preferenceLookupIds: this.preferenceLookupIds.length > 0 ? this.preferenceLookupIds : null,
      isActive: this.isActive,
      inactiveReason: this.inactiveReason
    };
  }
}
